import PurchaseHistory from "@/features/user/components/purchase-history/purchasehistory";
import { appTitleHead } from "@/lib/app-document-title";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/account/_auth/history")({
  head: () => appTitleHead("purchase-history-title"),
  component: PurchaseHistory
});
